module.exports = __webpack_public_path__ + "static/img/what-is.47e4fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/what-is.jpg
// module id = z7pg
// module chunks = 1